import React, { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../config";
import {
    Container,
    Card,
    CardContent,
    Typography,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    Button,
    CircularProgress,
    Snackbar,
    Alert
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import SchoolIcon from "@mui/icons-material/School";
import MenuBookIcon from "@mui/icons-material/MenuBook";
const HomeWorkPage = () => {
    //-----------------------------------------------------
    // Logged Staff
    //-----------------------------------------------------
    const [staffRegID] = useState(
        sessionStorage.getItem("adminRegId")
    );
    //-----------------------------------------------------
    // Dropdown Lists
    //-----------------------------------------------------
    const [courses,setCourses]=useState([]);
    const [years,setYears]=useState([]);
    const [classes,setClasses]=useState([]);
    const [sections,setSections]=useState([]);
    const [subjects,setSubjects]=useState([]);
    //-----------------------------------------------------
    // Selected Values
    //-----------------------------------------------------
    const [selectedCourse,setSelectedCourse]=useState("");
    const [selectedYear,setSelectedYear]=useState("");
    const [selectedClass,setSelectedClass]=useState("");
    const [selectedSection,setSelectedSection]=useState("");
    const [selectedSubject,setSelectedSubject]=useState("");
    //-----------------------------------------------------
    // Homework
    //-----------------------------------------------------
    const [homework,setHomework]=useState("");
    //-----------------------------------------------------
    // UI
    //-----------------------------------------------------
    const [showSection,setShowSection]=useState(false);
    const [loading,setLoading]=useState(false);
    const [snack,setSnack]=useState({
        open:false,
        severity:"success",
        message:""
    });
    //-----------------------------------------------------
    // Load Courses
    //-----------------------------------------------------
    useEffect(()=>{
        loadCourses();
    },[]);
    //-----------------------------------------------------
    // Load Academic Year
    //-----------------------------------------------------
    useEffect(()=>{
        if(selectedCourse){
            loadAcademicYears();
            loadClasses();
        }
        else{
            setYears([]);
            setClasses([]);
            setSubjects([]);
            setSections([]);
        }
    },[selectedCourse]);
    //-----------------------------------------------------
    // Class Changed
    //-----------------------------------------------------
    useEffect(()=>{
        if(selectedClass){
            loadSections();
        }
    },[selectedClass]);
    //-----------------------------------------------------
    // Subject Changed
    //-----------------------------------------------------
    useEffect(()=>{
        if(
            selectedCourse &&
            selectedYear &&
            selectedClass
        ){
            loadSubjects();
        }
    },[
        selectedCourse,
        selectedYear,
        selectedClass,
        selectedSection
    ]);
    //-----------------------------------------------------
    // Load Courses
    //-----------------------------------------------------
    const loadCourses=async()=>{
        try{
            const res=await axios.get(
                `${BASE_URL}/api/homework/courses`,
                {
                    params:{
                        staffRegID
                    }
                }
            );
             console.log(res.data);
            setCourses(res.data);
        }
        catch(err){
            console.log(err);
        }
    };
    //-----------------------------------------------------
    // Load Academic Years
    //-----------------------------------------------------
    const loadAcademicYears=async()=>{
        try{
            const res = await axios.get(
    `${BASE_URL}/api/homework/academicYears/${selectedCourse}`,
    {
        params:{
            staffRegID
        }
    }
);
            setYears(res.data);
        }
        catch(err){
            console.log(err);
        }
    };
    //-----------------------------------------------------
    // Load Classes
    //-----------------------------------------------------
    const loadClasses=async()=>{
        try{
            const res=await axios.get(
                `${BASE_URL}/api/homework/classes`,
                {
                    params:{
                        staffRegID,
                        courseId:selectedCourse
                    }
                }
            );
            setClasses(res.data);
        }
        catch(err){
            console.log(err);
        }
    };
    //-----------------------------------------------------
    // Load Sections
    //-----------------------------------------------------
    const loadSections=async()=>{
        try{
            const res=await axios.get(

`${BASE_URL}/api/homework/sections/${selectedClass}`,

{
    params:{
        staffRegID,
        courseId:selectedCourse
    }
});
            if(res.data.length>0){
                setSections(res.data);
                setShowSection(true);
            }
            else{
                setSections([]);
                setShowSection(false);
                setSelectedSection("");
            }
        }
        catch(err){
            console.log(err);
        }
    };
    //-----------------------------------------------------
    // Load Subjects
    //-----------------------------------------------------
    const loadSubjects=async()=>{
        try{
            const res=await axios.get(
                `${BASE_URL}/api/homework/subjects`,
                {
                    params:{
                        staffRegID,
                        courseId:selectedCourse,
                        academicYearId:selectedYear,
                        classId:selectedClass,
                        sectionId:
                        showSection
                        ? selectedSection
                        : null
                    }
                }
            );
            setSubjects(res.data);
        }
        catch(err){
            console.log(err);
        }
    };
    //-----------------------------------------------------
    // Send Homework
    //-----------------------------------------------------
    const handleSend=async()=>{
        if(!selectedCourse){
            return setSnack({
                open:true,
                severity:"error",
                message:"Select Course"
            });
        }
        if(!selectedYear){
            return setSnack({
                open:true,
                severity:"error",
                message:"Select Academic Year"
            });
        }
        if(!selectedClass){
            return setSnack({
                open:true,
                severity:"error",
                message:"Select Class"
            });
        }
        if(showSection && !selectedSection){
            return setSnack({
                open:true,
                severity:"error",
                message:"Select Section"
            });
        }
        if(!selectedSubject){
            return setSnack({
                open:true,
                severity:"error",
                message:"Select Subject"
            });
        }
        if(homework.trim()===""){
            return setSnack({
                open:true,
                severity:"error",
                message:"Enter Homework"
            });
        }
        if(homework.length>30){
            return setSnack({
                open:true,
                severity:"error",
                message:"Maximum 30 characters"
            });
        }
        try{
            setLoading(true);
            await axios.post(
                `${BASE_URL}/api/homework/send`,
                {
                    StaffRegID:staffRegID,
                    CourseID:selectedCourse,
                    AcademicYearID:selectedYear,
                    ClassID:selectedClass,
                    SectionID:
                    showSection
                    ? selectedSection
                    : null,
                    SubjectID:selectedSubject,
                    Homework:homework
                }
            );
            setSnack({
                open:true,
                severity:"success",
                message:"Homework sent successfully."
            });
            setHomework("");
        }
        catch(err){
            setSnack({
                open:true,
                severity:"error",
                message:
                err.response?.data?.message ||
                "Unable to send homework."
            });
        }
        finally{
            setLoading(false);
        }
    };
    return (
<Container maxWidth="md" sx={{ mt:4, mb:4 }}>
<Card
elevation={6}
sx={{
borderRadius:3
}}
>
<CardContent>
{/*---------------------------------------*/}
{/* HEADER */}
{/*---------------------------------------*/}
<Typography
variant="h4"
align="center"
fontWeight="bold"
color="primary"
gutterBottom
>
<SchoolIcon
sx={{
fontSize:40,
mr:1,
verticalAlign:"middle"
}}
/>
Send Homework
</Typography>
<Typography
align="center"
color="text.secondary"
mb={4}
>
Homework will be sent to all parents through SMS.
</Typography>
<Grid
container
spacing={3}
>
{/*---------------------------------------*/}
{/* COURSE */}
{/*---------------------------------------*/}
<Grid item xs={12} md={6}>
<FormControl fullWidth>
<InputLabel>
Course
</InputLabel>
<Select
value={selectedCourse}
label="Course"
onChange={(e)=>{
setSelectedCourse(e.target.value);
setSelectedYear("");
setSelectedClass("");
setSelectedSection("");
setSelectedSubject("");
}}
>
<MenuItem value="">
Select Course
</MenuItem>
{
courses.map(course=>(
<MenuItem
key={course.CourseID}
value={course.CourseID}
>
{course.CourseName}
</MenuItem>
))
}
</Select>
</FormControl>
</Grid>
{/*---------------------------------------*/}
{/* ACADEMIC YEAR */}
{/*---------------------------------------*/}
<Grid item xs={12} md={6}>
<FormControl fullWidth>
<InputLabel>
Academic Year
</InputLabel>
<Select
value={selectedYear}
label="Academic Year"
onChange={(e)=>{
setSelectedYear(e.target.value);
}}
>
<MenuItem value="">
Select Academic Year
</MenuItem>
{
years.map(year=>(
<MenuItem
key={year.AcademicYearID}
value={year.AcademicYearID}
>
{year.AcademicYearName}
</MenuItem>
))
}
</Select>
</FormControl>
</Grid>
{/*---------------------------------------*/}
{/* CLASS */}
{/*---------------------------------------*/}
<Grid item xs={12} md={6}>
<FormControl fullWidth>
<InputLabel>
Class
</InputLabel>
<Select
value={selectedClass}
label="Class"
onChange={(e)=>{
setSelectedClass(e.target.value);
}}
>
<MenuItem value="">
Select Class
</MenuItem>
{
classes.map(cls=>(
<MenuItem
key={cls.ClassID}
value={cls.ClassID}
>
{cls.ClassName}
</MenuItem>
))
}
</Select>
</FormControl>
</Grid>
{/*---------------------------------------*/}
{/* SECTION */}
{/*---------------------------------------*/}
{
showSection &&
<Grid item xs={12} md={6}>
<FormControl fullWidth>
<InputLabel>
Section
</InputLabel>
<Select
value={selectedSection}
label="Section"
onChange={(e)=>{
setSelectedSection(e.target.value);
}}
>
<MenuItem value="">
Select Section
</MenuItem>
{
sections.map(sec=>(
<MenuItem
key={sec.SectionID}
value={sec.SectionID}
>
{sec.SectionName}
</MenuItem>
))
}
</Select>
</FormControl>
</Grid>
}
{/*---------------------------------------*/}
{/* SUBJECT */}
{/*---------------------------------------*/}
<Grid item xs={12}>
<FormControl fullWidth>
<InputLabel>
Subject
</InputLabel>
<Select
value={selectedSubject}
label="Subject"
onChange={(e)=>{
setSelectedSubject(e.target.value);
}}
>
<MenuItem value="">
Select Subject
</MenuItem>
{
subjects.map(subject=>(
<MenuItem
key={subject.SubjectID}
value={subject.SubjectID}
>
{subject.SubjectName}
</MenuItem>
))
}
</Select>
</FormControl>
</Grid>
{/*---------------------------------------*/}
{/* HOMEWORK */}
{/*---------------------------------------*/}
<Grid item xs={12}>
<TextField
fullWidth
label="Homework"
placeholder="Enter Homework"
value={homework}
onChange={(e)=>{
if(e.target.value.length<=30){
setHomework(e.target.value);
}
}}
multiline
rows={4}
/>
<Typography
align="right"
variant="caption"
color={
homework.length>=30
?
"error"
:
"text.secondary"
}
>
{homework.length}/30 Characters
</Typography>
</Grid>
{/*---------------------------------------*/}
{/* BUTTON */}
{/*---------------------------------------*/}
<Grid
item
xs={12}
>
<Button
fullWidth
size="large"
variant="contained"
color="primary"
startIcon={
loading
?
<CircularProgress
size={20}
color="inherit"
/>
:
<SendIcon/>
}
disabled={loading}
onClick={handleSend}
>
{
loading
?
"Sending Homework..."
:
"Send Homework"
}
</Button>
</Grid>
</Grid>
</CardContent>
</Card>
{/*---------------------------------------*/}
{/* SNACKBAR */}
{/*---------------------------------------*/}
<Snackbar
open={snack.open}
autoHideDuration={4000}
onClose={()=>{
setSnack({
...snack,
open:false
});
}}
anchorOrigin={{
vertical:"top",
horizontal:"center"
}}
>
<Alert
severity={snack.severity}
variant="filled"
sx={{
width:"100%"
}}
>
{snack.message}
</Alert>
</Snackbar>
</Container>
);
}
export default HomeWorkPage;